import React from 'react';
import { IoCheckmarkCircle, IoWarning } from 'react-icons/io5';

import useSubscriptionStatus from './useSubscriptionStatus';
import './styles.css';

const SubscriptionBar = () => {
    const status = useSubscriptionStatus();

    if (!status) return null;

    return (
        <div
            className="subscription-bar"
            style={{
                background: status.background,
                color: status.color,
                borderBottom: `1px solid ${status.border}`,
            }}
        >
            {status.key === 'active' ? <IoCheckmarkCircle size={15} /> : <IoWarning size={15} />}
            <span>{status.message}</span>
        </div>
    );
};

export default SubscriptionBar;
